import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useClerk } from "@clerk/react";
import { Navigate } from "react-router-dom";
import { Loader2, ShieldAlert } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useApi } from "@/lib/api";

const AdminCtx = createContext(null);
export const useAdmin = () => useContext(AdminCtx);

export function FullScreenLoader({ label = "Caricamento…" }) {
  return (
    <div className="min-h-screen flex items-center justify-center gap-3 text-slate-500" data-testid="fullscreen-loader">
      <Loader2 className="animate-spin" size={18} /> <span className="text-sm">{label}</span>
    </div>
  );
}

function NotAuthorized({ email }) {
  const { signOut } = useClerk();
  return (
    <div className="min-h-screen flex items-center justify-center bg-navy-900 p-6" data-testid="not-authorized-page">
      <div className="max-w-md bg-white rounded-xl p-8">
        <ShieldAlert className="text-amber-600" />
        <h1 className="mt-4 text-xl font-semibold text-slate-900">Accesso non autorizzato</h1>
        <p className="mt-2 text-sm text-slate-600">L'account {email || ""} non ha accesso alla dashboard di MUSORA. Se hai ricevuto un link a una demo, aprilo direttamente.</p>
        <Button className="mt-6" variant="outline" onClick={() => signOut()} data-testid="not-authorized-signout-btn">Esci</Button>
      </div>
    </div>
  );
}

export default function AdminGate({ children }) {
  const api = useApi();
  const [me, setMe] = useState(null);
  const [settings, setSettings] = useState(null);
  const [error, setError] = useState(false);

  const refreshSettings = useCallback(async () => {
    const { data } = await api.get("/settings");
    setSettings(data);
    return data;
  }, [api]);

  useEffect(() => {
    api.get("/me").then(async ({ data }) => {
      setMe(data);
      if (data.role === "admin") await refreshSettings();
    }).catch(() => setError(true));
  }, [api, refreshSettings]);

  if (error) return <NotAuthorized />;
  if (!me || (me.role === "admin" && !settings)) return <FullScreenLoader />;
  if (me.role !== "admin") return <Navigate to="/area" replace />;  // client members: their own area, never the ADM Studio
  return <AdminCtx.Provider value={{ me, settings, refreshSettings }}>{children}</AdminCtx.Provider>;
}
